export default "__VITE_ASSET__B4WTeQd1__"